import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10, border: "1px solid #ccc", borderRadius: "10px" }}>
            <div >{`${payload[0]['payload']['name']}: ${payload[0]['payload']['value']}`}</div>
        </div>
    );
}

return null;
};
const PRToPOBarChart = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart
                layout="vertical"
                width={"100%"}
                height={"100%"}
                data={data}
                margin={{
                    top: 20, right: 120, left: 50, bottom: 5,
            }}
            >
                <CartesianGrid horizontal={false} vertical={true} />
                <XAxis type="number"
                        axisLine={false}
                        tickLine={false} 
                        tick={{ fontSize: 14, fontWeight: "400", fontFamily: "Inter" }}/>
                <YAxis dataKey="name" type="category"
                                axisLine={false}
                                tickLine={false} />
                <Tooltip cursor={false} content={<CustomTooltip />} />
                <Bar dataKey="value" barSize={11} radius={[0, 10, 10, 0]}>
                    {data.map((entry, index) => (
                        <Bar dataKey="value" fill={entry.fill} key={`bar-${index}`} />
                    ))}
                    <LabelList dataKey="value" position="right" fill="#616161" style={{ fontSize: 10, fontWeight: 700, color: "#616161" }} />
                </Bar>
            </BarChart>
            
        </ResponsiveContainer>
        );
    };

export default PRToPOBarChart;
